import React from 'react';
import { MousePointer, DollarSign, UserCheck } from 'lucide-react';

const steps = [
  {
    icon: MousePointer,
    title: 'Click Buy or Sell',
    description: 'Select your transaction type at the BTM'
  },
  {
    icon: DollarSign,
    title: 'Select Amount',
    description: 'Choose how much you want to buy or sell'
  },
  {
    icon: UserCheck,
    title: 'Follow KYC Prompts',
    description: 'Complete the verification process'
  }
];

export default function HowItWorks() {
  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <h3 className="text-2xl font-bold text-white mb-8 text-center">How It Works</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center mb-4">
              <step.icon className="w-8 h-8 text-purple-500" />
            </div>
            <h4 className="text-lg font-semibold text-white mb-2">{step.title}</h4>
            <p className="text-gray-400">{step.description}</p>
            {index < steps.length - 1 && (
              <div className="hidden md:block absolute right-0 top-1/2 w-full h-0.5 bg-purple-500/20" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}